import { ProdutoCodbarPopupComponent } from './../produto-codbar-popup/produto-codbar-popup.component';
import { FatClassFiscalService } from './../../../../../shared/services/fat-class-fiscal.service';
import { DOCUMENT } from '@angular/common';
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Inject, OnDestroy, OnInit, Optional, QueryList, ViewChild, ViewChildren } from '@angular/core';
import { FormBuilder, FormGroup, Validators, FormControl } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatSelect } from '@angular/material/select';
import { ActivatedRoute, Router } from '@angular/router';
import { Cidade } from '../../../../../shared/interfaces/cidade';
import { Endereco } from '../../../../../shared/interfaces/endereco';
import { GrupoProdutos } from '../../../../../shared/interfaces/grupo-produtos';
import { Marca } from '../../../../../shared/interfaces/marca';
import { PageResult } from '../../../../../shared/interfaces/page-result';
import { Produto } from '../../../../../shared/interfaces/produto';
import { ProdutoMovto } from '../../../../../shared/interfaces/produto-movto';
import { UnMedida } from '../../../../../shared/interfaces/un-medida';
import { AppConfirmService } from '../../../../../shared/services/app-confirm/app-confirm.service';
import { AppLoaderService } from '../../../../../shared/services/app-loader/app-loader.service';
import { JwtAuthService } from '../../../../../shared/services/auth/jwt-auth.service';
import { FatClassTipiService } from '../../../../../shared/services/fat-class-tipi.service';
import { FatDoctoCService } from '../../../../../shared/services/fat-docto-c.service';
import { MarcaService } from '../../../../../shared/services/marca.service';
import { ProdutoGrupoService } from '../../../../../shared/services/produto-grupo.service';
import { ProdutoUnMedidaService } from '../../../../../shared/services/produto-un-medida.service';
import { ProdutoService } from '../../../../../shared/services/produto.service';
import { LancamentoDetailsComponent } from '../../../../../views/movimentacao/faturamento/lancamento/lancamento-details/lancamento-details.component';
import { ClassificacaoGerencialService } from '../../../../../shared/services/classificacao-gerencial.service';
// tslint:disable-next-line:max-line-length
import { BehaviorSubject, Observable, Subscription, Subject, Subscriber } from 'rxjs';
import { debounceTime, finalize, switchMap, tap, filter, takeUntil, map, delay, distinctUntilChanged } from 'rxjs/operators';
import { LayoutService } from '../../../../../shared/services/layout.service';
import { ProdutoMovtoPopupComponent } from '../produto-movto-popup/produto-movto-popup.component';
import { ProdutoTribPopupComponent } from '../produto-trib-popup/produto-trib-popup.component';
import { ProdutoPrecoPopupComponent } from '../produto-preco-popup/produto-preco-popup.component';
import { ProdutoImagesPopupComponent } from '../produto-images-popup/produto-images-popup.component';
import { ProdutoEnums } from '../../../../../shared/interfaces/produto-enums';
import { ProdutoAnexoUploadListComponent } from '../produto-anexo-upload-list/produto-anexo-upload-list.component';
import { AutomBombaService } from '../../../../../shared/services/autom-bomba .service';
import { AutomBomba } from '../../../../../shared/interfaces/autom-bomba';
import { ClassificacaoGerencial } from '../../../../../shared/interfaces/classificacao-gerencial';

interface SelectPaginationState {
  currentPage: number;
  totalPages: number;
  searchTerm: string;
  loadingMore: boolean;
  panelElement?: HTMLElement;
  scrollHandler?: EventListener;
}

@Component({
  selector: 'app-produto-details',
  templateUrl: './produto-details.component.html',
  styleUrls: ['./produto-details.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,

})
export class ProdutoDetailsComponent implements OnInit, OnDestroy {

  @ViewChild('grupoSelect') grupoSelect?: MatSelect;
  @ViewChild('marcaSelect') marcaSelect?: MatSelect;
  @ViewChild('classificacaoSelect') classificacaoSelect?: MatSelect;
  @ViewChild('automBombaSelect') automBombaSelect?: MatSelect;
  @ViewChildren('unidadeSelect') unidadeSelects?: QueryList<MatSelect>;

  layoutConf: any;

  public hasBaseDropZoneOver = false;
  dialogRef: MatDialogRef<any>;
  itemForm: FormGroup;

  itemFormSub: Subscription;
  itemDiretivasFatForm: FormGroup;
  produtoCodigo: number;
  produto: Produto;
  grupo: GrupoProdutos;

  showEditOption = true;
  filtroCidades: Cidade[] = [];
  cidades: Cidade[];


  public searching = false;
  protected _onDestroy = new Subject<void>();
  private _formDestroy = new Subject<void>();

  isLoadingFatMarca: boolean;
  fatMarcas: Marca[] = [];
  fatMarca: Marca;

  isLoadingCadUnidade1 = false;
  unidades$: BehaviorSubject<UnMedida[]> = new BehaviorSubject<UnMedida[]>([]);
  cadUnidade1: UnMedida;
  isLoadingCadUnidade2: boolean;
  cadUnidade2: any;
  isLoadingCadUnidade3: boolean;
  cadUnidade3: any;
  isLoadingCadUnidade4: boolean;
  cadUnidade4: any;
  isLoadingCadUnidadePadraoVenda: boolean;
  cadUnidadePadraoVenda: any;
  isLoading = false;
  isLoadingGrupo = false;
  grupos: GrupoProdutos[] = [];
  automBombas: AutomBomba[] = [];
  public medidas: UnMedida[] = [];
  selectedTabIndex = 0;
  errorMsg: string;

  isLoadingClassGerencial = false;
  classificacoesGerenciais$: BehaviorSubject<ClassificacaoGerencial[]> = new BehaviorSubject<ClassificacaoGerencial[]>([]);
  classificacaoGerencial: ClassificacaoGerencial;

  countDown: Subscription;

  counter = 20;
  tick = 1000;


  @ViewChild(MatPaginator, { static: false }) paginator: MatPaginator;

  @ViewChild(MatPaginator, { static: false }) paginatorEndereco: MatPaginator;


  pageObject$: BehaviorSubject<PageResult<ProdutoMovto>> = new BehaviorSubject<PageResult<ProdutoMovto>>(null);
  movtos: ProdutoMovto[];
  page = 1;
  length = 0;
  pageSize = 5;
  pageEvent = null;
  pageSizeOptions: number[] = [5, 10, 25];

  selectedOrdem = 'NENHUM';
  selectedDirect = 'ASC';

  pageObjectEndereco$: BehaviorSubject<PageResult<Endereco>> = new BehaviorSubject<PageResult<Endereco>>(null);
  public enderecos: Endereco[];
  pageEndereco = 1;
  lengthEndereco = 0;
  pageSizeEndereco = 5;
  pageEventEndereco = null;
  pageSizeOptionsEndereco: number[] = [5, 10, 25];

  enums: ProdutoEnums;
  dialogRefTrib: MatDialogRef<any>

  private readonly categoriaPageSize = 50;
  private readonly classificacaoPageSize = 25;
  private readonly automBombaPageSize = 25;
  private grupoPagination = this.createPaginationState();
  private marcaPagination = this.createPaginationState();
  private unidadePagination = this.createPaginationState();
  private classificacaoPagination = this.createPaginationState();
  private automBombaPagination = this.createPaginationState();





  maskFone = { mask: '(00) {*}0000-0000', lazy: true, placeholderChar: '_' };
  maskCep = { mask: '00000-000', lazy: true, placeholderChar: '_' };
  maskCpf = { mask: '000.000.000-00', lazy: true, placeholderChar: '_' };
  maskCnpj = { mask: 'SS.SSS.SSS/SSSS-00', definitions: { S: /[0-9A-Za-z]/ }, prepare: (str: string) => (str || '').toUpperCase(), lazy: true, placeholderChar: '_' };
  maskUpper = { mask: /^\w\s*/, prepare: (str: any) => str.toUpperCase() };
  maskLower = { mask: /^\w\s*/, prepare: (str: any) => str.toLowerCase() };
  maskEmail = { mask: /^\S*@?\S*$/, prepare: (email: any) => email.toLowerCase() };
  maskCodigoBarra = { mask: '0000000000000{*}', lazy: true, placeholderChar: '_' };
  maskData = { mask: '00/00/0000', lazy: true, placeholderChar: '_' };

  cnpjReceitaWsResult: any = null;
  cnpjReceitaResult: any = null;
  cnpjReceitaResult2: any;
  cnpjReceitaResult3: Object;
  cnpjReceitaWsResult2: string;
  produtoSelected: Produto;





  oldIndex: number;

  locationUrl = '/produto_detail/';
  changeLocationUrl = this.locationUrl;
  isSaving: boolean;
  private readonly emptyControl = new FormControl('');

  constructor(
    @Optional() @Inject(MAT_DIALOG_DATA) public data: any,
    public dialogRefProdutoDetail: MatDialogRef<ProdutoDetailsComponent>,
    private fb: FormBuilder,
    private route: ActivatedRoute,
    private router: Router,
    private snack: MatSnackBar,
    private dialog: MatDialog,
    private produtoService: ProdutoService,
    private automBombaService: AutomBombaService,
    public jwtAuthService: JwtAuthService,
    private grupoService: ProdutoGrupoService,
    private unMedidaService: ProdutoUnMedidaService,
    private fatMarcaService: MarcaService,
    private fatClassTipiService: FatClassTipiService,
    private fatClassFiscalService: FatClassFiscalService,
    private fatDoctoCService: FatDoctoCService,
    private loader: AppLoaderService,
    private confirmService: AppConfirmService,
    private cdr: ChangeDetectorRef,
    private layout: LayoutService,
    private classificacaoGerencialService: ClassificacaoGerencialService,
    @Inject(DOCUMENT) private document: Document
  ) {
    // Verifica se o componente foi chamado como popup
    // if (this.data) {
    //   this.produto = this.data.produto;
    // }
  }

  ngOnInit() {
    this.layoutConf = this.layout.layoutConf;

    // Verifica se o componente foi chamado como popup
    if (this.data?.produto?.id) {
      // Chamado como popup
      console.log('Chamado como popup');
      this.produtoCodigo = this.data.produto.codigo;
      console.log(`produtoCodigo: ${this.produtoCodigo}`);
    } else {
      // Chamado pela rota
      console.log('Chamado pela rota');
      this.produtoCodigo = this.route.snapshot.params['codigo'];
    }

    this.showEditOption = true; // Permite edição no popup
    this.selectedTabIndex = this.route.snapshot.params['tabIndex'] ?? 0;

    // Carrega dados necessários para o formulário
    this.loadGrupoPage(1, '', false);
    this.loadMarcaPage(1, '', false);
    this.unMedidaService.getUnMedidaList().subscribe(uns => this.medidas = uns);
    this.produtoService.getEnums().subscribe(enums => {
      this.enums = enums;
      console.log(`tipo produto Autom... ${JSON.stringify(this.enums.tipoProdutoAutom)}`);
    });

    this.loadAutomBombaPage(1, '', false);

    if (this.produtoCodigo) {
      this.getProduto();
      this.showEditOption = false; // Desabilita edição se chamado pela rota
    } else {
      this.createProduto();
      this.showEditOption = true; // Permite edição para novos produtos
    }

    this.pageObject$.subscribe(
      page => {
        if (page != null) {
          this.movtos = page.content;
          this.length = page.totalElements;
          this.pageSize = page.size;
          this.page = page.number;
          if (this.page === 1) {
            this.paginator.firstPage();
          }
        } else {
          this.movtos = [];
        }
      });

  }

  ngOnDestroy() {
    this._onDestroy.next();
    this._onDestroy.complete();
    this._formDestroy.next();
    this._formDestroy.complete();
  }

  private setupFormListeners() {
    this.setupPaginatedSearch<ClassificacaoGerencial>(
      'searchClassificacaoGerencial',
      search => this.getClassificacaoPageRequest(1, search),
      (result, search) => {
        this.classificacaoPagination.searchTerm = search;
        const content = result?.content || [];
        const current = this.classificacoesGerenciais$.value || [];
        const nextList = content.length ? content : current;
        this.classificacoesGerenciais$.next(nextList);
        this.selectClassificacaoGerencial();
        this.classificacaoPagination.currentPage = result?.number || 1;
        this.classificacaoPagination.totalPages = result?.totalPages || 1;
      },
      'A T E N Ç Ã O ! ERRO PESQUISANDO CLASSIFICAÇÃO GERENCIAL ... '
    );

    this.setupPaginatedSearch<AutomBomba>(
      'searchAutomBomba',
      search => this.getAutomBombaPageRequest(1, search),
      (result, search) => {
        this.automBombaPagination.searchTerm = search;
        const content = result?.content || [];
        this.automBombas = this.appendUniqueById([], content);
        if (this.produto?.automBomba && !this.automBombas.some(bomba => bomba?.id === this.produto.automBomba?.id)) {
          this.automBombas.unshift(this.produto.automBomba);
        }
        this.automBombaPagination.currentPage = result?.number || 1;
        this.automBombaPagination.totalPages = result?.totalPages || 1;
      },
      'A T E N Ç Ã O !  ERRO PESQUISANDO CADASTRO DE BOMBAS ... '
    );

    this.setupPaginatedSearch<GrupoProdutos>(
      'searchGrupo',
      search => this.getGrupoPageRequest(1, search),
      (result, search) => {
        this.grupoPagination.searchTerm = search;
        this.grupos = this.mergeGrupoSelecionado(result?.content || []);
        this.grupoPagination.currentPage = result?.number || 1;
        this.grupoPagination.totalPages = result?.totalPages || 1;
      },
      'A T E N Ç Ã O !  ERRO PESQUISANDO GRUPO/CATEGORIA ... '
    );

    this.setupPaginatedSearch<Marca>(
      'searchMarca',
      search => this.getMarcaPageRequest(1, search),
      (result, search) => {
        this.marcaPagination.searchTerm = search;
        this.fatMarcas = this.mergeMarcaSelecionada(result?.content || []);
        this.marcaPagination.currentPage = result?.number || 1;
        this.marcaPagination.totalPages = result?.totalPages || 1;
      },
      'A T E N Ç Ã O !  ERRO PESQUISANDO MARCA ... '
    );

    this.setupUnidadeSearch('searchUnidade1');
    this.setupUnidadeSearch('searchUnidade2');
    this.setupUnidadeSearch('searchUnidade3');
    this.setupUnidadeSearch('searchUnidade4');
    this.setupUnidadeSearch('searchUnidadePadrao');

  }


  private selectClassificacaoGerencial() {
    if (this.produto?.classificacaoGerencial) {
      const currentClassificacoes = this.classificacoesGerenciais$.value;
      if (currentClassificacoes.map(c => c.id).includes(this.produto.classificacaoGerencial.id)) {
        const classificacao = currentClassificacoes.find(c => c.id === this.produto.classificacaoGerencial.id) ?? this.produto.classificacaoGerencial;
        if (classificacao) {
          this.itemForm.controls['classificacaoGerencial'].setValue(classificacao);
        }
      } else {
        currentClassificacoes.push(this.produto.classificacaoGerencial);
        this.classificacoesGerenciais$.next(currentClassificacoes);
        this.itemForm.controls['classificacaoGerencial'].setValue(this.produto.classificacaoGerencial);
      }
    }
  }


  private selectCadUnidade1() {
    if (this.produto.cadUnidade1 !== undefined && this.produto.cadUnidade1 !== null) {
      if (this.unidades$.value.map(n => n.id).includes(this.produto.cadUnidade1.id)) {
        const un = this.unidades$.value.find(n => n.id === this.produto.cadUnidade1.id) ?? this.produto.cadUnidade1;
        if (un !== null && un !== undefined) {
          this.itemForm.controls['cadUnidade1'].setValue(un);
        }
      } else {
        const uns = this.unidades$.value;
        uns.push(this.produto.cadUnidade1);
        this.unidades$.next(uns);
      }
    }
  }

  private selectCadUnidade2() {
    if (this.produto.cadUnidade2 !== undefined && this.produto.cadUnidade2 !== null) {
      if (this.unidades$.value.map(n => n.id).includes(this.produto.cadUnidade2.id)) {
        const un = this.unidades$.value.find(n => n.id === this.produto.cadUnidade2.id) ?? this.produto.cadUnidade2;
        if (un !== null && un !== undefined) {
          this.itemForm.controls['cadUnidade2'].setValue(un);
        }
      } else {
        const uns = this.unidades$.value;
        uns.push(this.produto.cadUnidade2);
        this.unidades$.next(uns);
      }
    }
  }


  private selectCadUnidade3() {
    if (this.produto.cadUnidade3 !== undefined && this.produto.cadUnidade3 !== null) {
      if (this.unidades$.value.map(n => n.id).includes(this.produto.cadUnidade3.id)) {
        const un = this.unidades$.value.find(n => n.id === this.produto.cadUnidade3.id) ?? this.produto.cadUnidade3;
        if (un !== null && un !== undefined) {
          this.itemForm.controls['cadUnidade3'].setValue(un);
        }
      } else {
        const uns = this.unidades$.value;
        uns.push(this.produto.cadUnidade3);
        this.unidades$.next(uns);
      }
    }
  }

  private selectCadUnidade4() {
    if (this.produto.cadUnidade4 !== undefined && this.produto.cadUnidade4 !== null) {
      if (this.unidades$.value.map(n => n.id).includes(this.produto.cadUnidade4.id)) {
        const un = this.unidades$.value.find(n => n.id === this.produto.cadUnidade4.id) ?? this.produto.cadUnidade4;
        if (un !== null && un !== undefined) {
          this.itemForm.controls['cadUnidade4'].setValue(un);
        }
      } else {
        const uns = this.unidades$.value;
        uns.push(this.produto.cadUnidade4);
        this.unidades$.next(uns);
      }
    }
  }

  private selectCadUnidadePadraoVenda() {
    if (this.produto.cadUnidadePadraoVenda !== undefined && this.produto.cadUnidadePadraoVenda !== null) {
      if (this.unidades$.value.map(n => n.id).includes(this.produto.cadUnidadePadraoVenda.id)) {
        const un = this.unidades$.value.find(n => n.id === this.produto.cadUnidadePadraoVenda.id) ?? this.produto.cadUnidadePadraoVenda;
        if (un !== null && un !== undefined) {
          this.itemForm.controls['cadUnidadePadraoVenda'].setValue(un);
        }
      } else {
        const uns = this.unidades$.value;
        uns.push(this.produto.cadUnidadePadraoVenda);
        this.unidades$.next(uns);
      }
    }
  }



  private changeUrl() {
    this.changeLocationUrl = this.locationUrl + this.produto?.id + '/' + this.selectedTabIndex;
  }

  // ngOnDestroy() {
  //   this.document.body.classList.remove('print-body-content');
  // }

  createProduto() {
    this.produtoService.create().subscribe((produto) => {
      // Modo "incluir a partir da pesquisa" (ex.: LancamentoItens): pré-preenche a descrição
      // com o texto que o usuário digitou na busca, antes de montar o formulário.
      if (produto && !this.data?.produto?.id && this.data?.produto?.descricao) {
        produto.descricao = this.data.produto.descricao;
      }
      this.produto = produto;
      // this.buildProdutoForm(this.produto);
      this.cdr.markForCheck();
    });
  }

  getProduto() {
    this.loader.open();
    this.produtoService.getProdutoById(this.produtoCodigo).subscribe((produto) => {
      this.produto = produto;
      this.changeUrl();


      this.cdr.markForCheck();

      console.log('dentro do getprpduto');

      this.buildProdutoForm(this.produto);

      this.itemForm.controls['tipo'].setValue(this.produto.tipo)


      this.automBombas.push(this.produto.automBomba);
      this.itemForm.controls['automBomba'].setValue(this.produto?.automBomba);

      // this.itemForm.controls['tipoProdutoAutom'].setValue(this.produto?.tipoProdutoAutom);

      this.grupos = this.mergeGrupoSelecionado(this.grupos || []);
      this.itemForm.controls['fatGrupoprodutos'].setValue(this.produto.fatGrupoprodutos)

      console.log('dentro do getprpduto 2');

      this.fatMarcas = this.mergeMarcaSelecionada(this.fatMarcas || []);
      this.itemForm.controls['fatMarca'].setValue(this.produto.fatMarca);
      this.loadUnidadePage(1, '', false);
      this.selectCadUnidade1();
      this.selectCadUnidade2();
      this.selectCadUnidade3();
      this.selectCadUnidade4();
      this.selectCadUnidadePadraoVenda();

      // Garantir que classificações gerenciais estejam carregadas antes de selecionar
      this.loadClassificacaoPage(1, '', false);

    }, er => {
      this.loader.close();
      this.confirmService.confirm({ message: `ERRO AO CARREGAR PRODUTO: ${er.error.status}`, error: true })
        .subscribe(_ => this.router.navigateByUrl('produto_detail/list'));
    }, () => {
      this.loader.close();


    });

  }

  private mergeGrupoSelecionado(grupos: GrupoProdutos[]): GrupoProdutos[] {
    const list = Array.isArray(grupos) ? [...grupos] : [];
    const selecionado = this.itemForm?.controls['fatGrupoprodutos']?.value || this.produto?.fatGrupoprodutos;
    if (!selecionado?.id) {
      return list;
    }
    if (!list.some(g => g?.id === selecionado.id)) {
      list.unshift(selecionado);
    }
    return list;
  }

  private mergeMarcaSelecionada(marcas: Marca[]): Marca[] {
    const list = Array.isArray(marcas) ? [...marcas] : [];
    const selecionada = this.itemForm?.controls['fatMarca']?.value || this.produto?.fatMarca;
    if (!selecionada?.id) {
      return list;
    }
    if (!list.some(m => m?.id === selecionada.id)) {
      list.unshift(selecionada);
    }
    return list;
  }

  private mergeUnidadesSelecionadas(unidades: UnMedida[]): UnMedida[] {
    const list = Array.isArray(unidades) ? [...unidades] : [];
    const selecionadas = [
      this.itemForm?.controls['cadUnidade1']?.value || this.produto?.cadUnidade1,
      this.itemForm?.controls['cadUnidade2']?.value || this.produto?.cadUnidade2,
      this.itemForm?.controls['cadUnidade3']?.value || this.produto?.cadUnidade3,
      this.itemForm?.controls['cadUnidade4']?.value || this.produto?.cadUnidade4,
      this.itemForm?.controls['cadUnidadePadraoVenda']?.value || this.produto?.cadUnidadePadraoVenda,
    ].filter((u): u is UnMedida => !!u?.id);

    selecionadas.forEach(un => {
      if (!list.some(item => item?.id === un.id)) {
        list.unshift(un);
      }
    });

    return list;
  }

  private createPaginationState(): SelectPaginationState {
    return {
      currentPage: 1,
      totalPages: 1,
      searchTerm: '',
      loadingMore: false,
    };
  }

  private appendUniqueById<T extends { id?: any }>(current: T[], incoming: T[]): T[] {
    const result = Array.isArray(current) ? [...current] : [];
    (incoming || []).forEach(item => {
      if (!result.some(existing => existing?.id === item?.id)) {
        result.push(item);
      }
    });
    return result;
  }

  private bindPanelScroll(state: SelectPaginationState, panel: HTMLElement, loadNext: () => void): void {
    if (state.panelElement === panel) {
      return;
    }

    this.unbindPanelScroll(state);
    state.panelElement = panel;
    state.scrollHandler = () => {
      if (!state.panelElement || state.loadingMore || state.currentPage >= state.totalPages) {
        return;
      }

      const { scrollTop, scrollHeight, clientHeight } = state.panelElement;
      if (scrollTop + clientHeight < scrollHeight - 48) {
        return;
      }

      loadNext();
    };
    panel.addEventListener('scroll', state.scrollHandler, { passive: true });
  }

  private unbindPanelScroll(state: SelectPaginationState): void {
    if (state.panelElement && state.scrollHandler) {
      state.panelElement.removeEventListener('scroll', state.scrollHandler);
    }
    state.panelElement = undefined;
    state.scrollHandler = undefined;
  }

  private setupPaginatedSearch<T>(
    controlName: string,
    requestFactory: (search: string) => Observable<PageResult<T>>,
    onResult: (result: PageResult<T>, search: string) => void,
    errorMessage: string,
    normalizeSearch: (search: any) => string = (search) => (typeof search === 'string' ? search.trim() : '')
  ): void {
    this.itemForm.get(controlName)?.valueChanges
      .pipe(
        takeUntil(this._formDestroy),
        map(search => normalizeSearch(search)),
        debounceTime(250),
        distinctUntilChanged(),
        filter(search => search.length === 0 || search.length >= 2),
        tap(() => this.searching = true),
        switchMap(search => requestFactory(search).pipe(
          map(result => ({ result, search })),
          finalize(() => {
            this.searching = false;
            this.cdr.markForCheck();
          })
        ))
      )
      .subscribe(
        ({ result, search }) => onResult(result, search),
        error => {
          this.searching = false;
          this.confirmService.confirm({
            message: `${errorMessage}${error}`,
            error: true
          });
        }
      );
  }

  private getGrupoPageRequest(page: number, search: string): Observable<PageResult<GrupoProdutos>> {
    return search
      ? this.grupoService.getProdutoGrupoPageSearch(page, this.categoriaPageSize, search)
      : this.grupoService.getProdutoGrupoPage(page, this.categoriaPageSize);
  }

  private loadGrupoPage(page: number, search: string, append: boolean): void {
    if (this.grupoPagination.loadingMore) {
      return;
    }
    this.grupoPagination.loadingMore = true;
    this.getGrupoPageRequest(page, search)
      .pipe(takeUntil(this._formDestroy))
      .subscribe({
        next: response => {
          const content = response?.content || [];
          const nextList = append ? this.appendUniqueById(this.grupos, content) : content;
          this.grupos = this.mergeGrupoSelecionado(nextList);
          this.grupoPagination.currentPage = response?.number || 1;
          this.grupoPagination.totalPages = response?.totalPages || 1;
          this.grupoPagination.searchTerm = search;
          this.grupoPagination.loadingMore = false;
          this.cdr.markForCheck();
        },
        error: error => {
          this.grupoPagination.loadingMore = false;
          this.confirmService.confirm({ message: `A T E N Ç Ã O !  ERRO PESQUISANDO GRUPO/CATEGORIA ... ${error}`, error: true });
        }
      });
  }

  private getMarcaPageRequest(page: number, search: string): Observable<PageResult<Marca>> {
    return search
      ? this.fatMarcaService.getMarcaPageSearch(page, this.categoriaPageSize, search)
      : this.fatMarcaService.getMarcaPage(page, this.categoriaPageSize);
  }

  private loadMarcaPage(page: number, search: string, append: boolean): void {
    if (this.marcaPagination.loadingMore) {
      return;
    }
    this.marcaPagination.loadingMore = true;
    this.getMarcaPageRequest(page, search)
      .pipe(takeUntil(this._formDestroy))
      .subscribe({
        next: response => {
          const content = response?.content || [];
          const nextList = append ? this.appendUniqueById(this.fatMarcas, content) : content;
          this.fatMarcas = this.mergeMarcaSelecionada(nextList);
          this.marcaPagination.currentPage = response?.number || 1;
          this.marcaPagination.totalPages = response?.totalPages || 1;
          this.marcaPagination.searchTerm = search;
          this.marcaPagination.loadingMore = false;
          this.cdr.markForCheck();
        },
        error: error => {
          this.marcaPagination.loadingMore = false;
          this.confirmService.confirm({ message: `A T E N Ç Ã O !  ERRO PESQUISANDO MARCA ... ${error}`, error: true });
        }
      });
  }

  private getUnidadePageRequest(page: number, search: string): Observable<PageResult<UnMedida>> {
    return search
      ? this.unMedidaService.getUnMedidaPageSearch(page, this.categoriaPageSize, search)
      : this.unMedidaService.getUnMedidaPage(page, this.categoriaPageSize);
  }

  private loadUnidadePage(page: number, search: string, append: boolean): void {
    if (this.unidadePagination.loadingMore) {
      return;
    }
    this.unidadePagination.loadingMore = true;
    this.getUnidadePageRequest(page, search)
      .pipe(takeUntil(this._formDestroy))
      .subscribe({
        next: response => {
          const content = response?.content || [];
          const nextList = append ? this.appendUniqueById(this.unidades$.value, content) : content;
          this.unidades$.next(this.mergeUnidadesSelecionadas(nextList));
          this.unidadePagination.currentPage = response?.number || 1;
          this.unidadePagination.totalPages = response?.totalPages || 1;
          this.unidadePagination.searchTerm = search;
          this.unidadePagination.loadingMore = false;
          this.cdr.markForCheck();
        },
        error: error => {
          this.unidadePagination.loadingMore = false;
          this.confirmService.confirm({ message: `A T E N Ç Ã O !  ERRO PESQUISANDO UNIDADES ... ${error}`, error: true });
        }
      });
  }

  private getClassificacaoPageRequest(page: number, search: string): Observable<PageResult<ClassificacaoGerencial>> {
    return search
      ? this.classificacaoGerencialService.getClassificacaoGPageSearch(page, this.classificacaoPageSize, search)
      : this.classificacaoGerencialService.getClassificacaoGPage(page, this.classificacaoPageSize);
  }

  private loadClassificacaoPage(page: number, search: string, append: boolean): void {
    if (this.classificacaoPagination.loadingMore) {
      return;
    }
    this.classificacaoPagination.loadingMore = true;
    this.getClassificacaoPageRequest(page, search)
      .pipe(takeUntil(this._formDestroy))
      .subscribe({
        next: response => {
          const current = this.classificacoesGerenciais$.value || [];
          const content = response?.content || [];
          const nextList = append ? this.appendUniqueById(current, content) : content;
          this.classificacoesGerenciais$.next(nextList);
          this.selectClassificacaoGerencial();
          this.classificacaoPagination.currentPage = response?.number || 1;
          this.classificacaoPagination.totalPages = response?.totalPages || 1;
          this.classificacaoPagination.searchTerm = search;
          this.classificacaoPagination.loadingMore = false;
          this.cdr.markForCheck();
        },
        error: error => {
          this.classificacaoPagination.loadingMore = false;
          this.confirmService.confirm({ message: `A T E N Ç Ã O ! ERRO PESQUISANDO CLASSIFICAÇÃO GERENCIAL ... ${error}`, error: true });
        }
      });
  }

  private getAutomBombaPageRequest(page: number, search: string): Observable<PageResult<AutomBomba>> {
    return search
      ? this.automBombaService.getBombaPageSearch(page, this.automBombaPageSize, search)
      : this.automBombaService.getombaPage(page, this.automBombaPageSize);
  }

  private loadAutomBombaPage(page: number, search: string, append: boolean): void {
    if (this.automBombaPagination.loadingMore) {
      return;
    }
    this.automBombaPagination.loadingMore = true;
    this.getAutomBombaPageRequest(page, search)
      .pipe(takeUntil(this._formDestroy))
      .subscribe({
        next: response => {
          const content = response?.content || [];
          const nextList = append ? this.appendUniqueById(this.automBombas, content) : content;
          this.automBombas = Array.isArray(nextList) ? [...nextList] : [];
          if (this.produto?.automBomba && !this.automBombas.some(bomba => bomba?.id === this.produto.automBomba?.id)) {
            this.automBombas.unshift(this.produto.automBomba);
          }
          this.automBombaPagination.currentPage = response?.number || 1;
          this.automBombaPagination.totalPages = response?.totalPages || 1;
          this.automBombaPagination.searchTerm = search;
          this.automBombaPagination.loadingMore = false;
          this.cdr.markForCheck();
        },
        error: error => {
          this.automBombaPagination.loadingMore = false;
          this.confirmService.confirm({ message: `A T E N Ç Ã O !  ERRO PESQUISANDO CADASTRO DE BOMBAS ... ${error}`, error: true });
        }
      });
  }

  private setupUnidadeSearch(controlName: string): void {
    this.setupPaginatedSearch<UnMedida>(
      controlName,
      search => this.getUnidadePageRequest(1, search),
      (result, search) => {
        this.unidadePagination.searchTerm = search;
        this.unidades$.next(this.mergeUnidadesSelecionadas(result?.content || []));
        this.unidadePagination.currentPage = result?.number || 1;
        this.unidadePagination.totalPages = result?.totalPages || 1;
      },
      'A T E N Ç Ã O !  ERRO PESQUISANDO UNIDADES ... '
    );
  }

  private clearSearchControl(controlName: string): void {
    this.itemForm?.controls?.[controlName]?.setValue('', { emitEvent: false });
    this.searching = false;
  }

  onSelectOpenedChange(controlName: string, opened: boolean): void {
    if (controlName === 'searchMarca') {
      this.handlePaginatedOpenChange(opened, this.marcaPagination, this.marcaSelect, () => this.loadMarcaPage(this.marcaPagination.currentPage + 1, this.marcaPagination.searchTerm, true), () => this.loadMarcaPage(1, '', false));
    }

    if (controlName === 'searchClassificacaoGerencial') {
      this.handlePaginatedOpenChange(opened, this.classificacaoPagination, this.classificacaoSelect, () => this.loadClassificacaoPage(this.classificacaoPagination.currentPage + 1, this.classificacaoPagination.searchTerm, true), () => this.loadClassificacaoPage(1, '', false));
    }

    if (controlName === 'searchAutomBomba') {
      this.handlePaginatedOpenChange(opened, this.automBombaPagination, this.automBombaSelect, () => this.loadAutomBombaPage(this.automBombaPagination.currentPage + 1, this.automBombaPagination.searchTerm, true), () => this.loadAutomBombaPage(1, '', false));
    }

    if (!opened) {
      this.clearSearchControl(controlName);
    }
  }

  onGrupoOpenedChange(opened: boolean): void {
    this.handlePaginatedOpenChange(opened, this.grupoPagination, this.grupoSelect, () => this.loadGrupoPage(this.grupoPagination.currentPage + 1, this.grupoPagination.searchTerm, true), () => this.loadGrupoPage(1, '', false));
    if (!opened) {
      this.clearSearchControl('searchGrupo');
    }
  }

  onUnidadeOpenedChange(controlName: string, opened: boolean): void {
    const currentSelect = this.unidadeSelects?.find(select => select.panelOpen);
    this.handlePaginatedOpenChange(opened, this.unidadePagination, currentSelect, () => this.loadUnidadePage(this.unidadePagination.currentPage + 1, this.unidadePagination.searchTerm, true), () => this.loadUnidadePage(1, '', false));
    if (!opened) {
      this.clearSearchControl(controlName);
    }
  }

  private handlePaginatedOpenChange(
    opened: boolean,
    state: SelectPaginationState,
    selectRef: MatSelect | undefined,
    loadNext: () => void,
    reloadDefault: () => void
  ): void {
    if (opened) {
      if (!state.searchTerm && state.currentPage === 1) {
        setTimeout(() => {
          const panel = selectRef?.panel?.nativeElement as HTMLElement | undefined;
          if (panel) {
            this.bindPanelScroll(state, panel, loadNext);
          }
        });
        return;
      }

      if (state.searchTerm) {
        reloadDefault();
      }

      setTimeout(() => {
        const panel = selectRef?.panel?.nativeElement as HTMLElement | undefined;
        if (panel) {
          this.bindPanelScroll(state, panel, loadNext);
        }
      });
      return;
    }

    this.unbindPanelScroll(state);
  }

  onSelectionChangeGrupo(event: any): void {
    const grupo = event?.value;
    if (!grupo) {
      return;
    }

    this.itemForm.controls['fatGrupoprodutos'].setValue(grupo, { emitEvent: false });
    this.grupos = this.mergeGrupoSelecionado(this.grupos || []);
    this.clearSearchControl('searchGrupo');
    this.cdr.markForCheck();
  }

  onSelectionChangeMarca(event: any): void {
    const marca = event?.value;
    if (!marca) {
      return;
    }

    this.itemForm.controls['fatMarca'].setValue(marca, { emitEvent: false });
    this.fatMarcas = this.mergeMarcaSelecionada(this.fatMarcas || []);
    this.clearSearchControl('searchMarca');
    this.cdr.markForCheck();
  }

  onSelectionChangeClassificacaoGerencial(event: any): void {
    const classificacao = event?.value;
    if (!classificacao) {
      return;
    }

    this.itemForm.controls['classificacaoGerencial'].setValue(classificacao, { emitEvent: false });
    this.clearSearchControl('searchClassificacaoGerencial');
    this.cdr.markForCheck();
  }

  onSelectionChangeAutomBomba(event: any): void {
    const bomba = event?.value;
    if (!bomba) {
      return;
    }

    this.itemForm.controls['automBomba'].setValue(bomba, { emitEvent: false });
    this.clearSearchControl('searchAutomBomba');
    this.cdr.markForCheck();
  }


  buildProdutoForm(produto: Produto) {
    this._formDestroy.next(); // cancela listeners do form anterior
    this.produtoSelected = produto;
    this.itemForm = this.fb.group({
      id: [produto?.id],
      codigo: [produto?.codigo],
      uuid: [produto?.uuid],
      desativado: [produto?.desativado],
      descricao: [produto?.descricao, [Validators.required]],
      fatGrupoprodutos: [produto?.fatGrupoprodutos, [Validators.required]],
      referencia: [produto?.referencia],
      localizacao: [produto?.localizacao],
      fatMarca: [produto?.fatMarca, [Validators.required]],
      cadUnidade1: [produto?.cadUnidade1, [Validators.required]],
      cadUnidadePadraoVenda: [produto?.cadUnidadePadraoVenda, [Validators.required]],
      cadUnidade2: [produto?.cadUnidade2],
      cadUnidade3: [produto?.cadUnidade3],
      cadUnidade4: [produto?.cadUnidade4],
      // unidadepadraovenda: [item?.unidadepadraovenda, [Validators.required]],
      classificacaoGerencial: [produto?.classificacaoGerencial],
      fatProdutoSaldo: [produto?.fatProdutoSaldo],
      codigoanp: [produto?.codigoanp],
      codigobarra1: [produto?.codigobarra1],
      codigobarra2: [produto?.codigobarra2],
      codigobarra3: [produto?.codigobarra3],
      codigobarra4: [produto?.codigobarra4],
      combNumeroBico: [produto?.combNumeroBico],
      combNumeroTanque: [produto?.combNumeroTanque],
      comissaoAliqPrazo: [produto?.comissaoAliqPrazo],
      comissaoAliqVista: [produto?.comissaoAliqVista],
      complemento: [produto?.complemento],

      dadosadicionais: [produto?.dadosadicionais],
      dadosadicionaisAsHtml: true,
      dataalteracao: [produto?.dataalteracao],
      datainclusao: [produto?.datainclusao],
      dataultimocusto: [produto?.dataultimocusto],
      fatorunidade1: [produto?.fatorunidade1],
      fatorunidade2: [produto?.fatorunidade2],
      fatorunidade3: [produto?.fatorunidade3],
      horaalteracao: [produto?.horaalteracao],
      horainclusao: [produto?.horainclusao],
      indIncentivo: [produto?.indIncentivo],
      indIss: [produto?.indIss],
      marca: [produto?.marca],

      ncmAliqImp: [produto?.ncmAliqImp],
      ncmAliqNac: [produto?.ncmAliqNac],
      ncmEx: [produto?.ncmEx],
      ncmTabela: [produto?.ncmTabela],
      percentualIpi: [produto?.percentualIpi],
      pesobruto: [produto?.pesobruto],
      pesoliquido: [produto?.pesoliquido],
      tipo: [produto?.tipo],
      ultimocusto: [produto?.ultimocusto],
      usuarioalteracao: [produto?.usuarioalteracao],
      usuarioinclusao: [produto?.usuarioinclusao],
      volume: [produto?.volume],
      fcpAliquota: [produto?.fcpAliquota],
      fcpSubstAliquota: [produto?.fcpSubstAliquota],
      fcpSubstAnteriorAliquota: [produto?.fcpSubstAnteriorAliquota],
      codigoBarraBalanca: [produto?.codigoBarraBalanca],
      layoutEtiquetaBalanca: [produto?.layoutEtiquetaBalanca],
      codigoMlb: [produto?.codigoMlb],
      categoryMlb: [produto?.categoryMlb],
      stopTimeMlb: [produto?.stopTimeMlb],
      produtoNovo: [produto?.produtoNovo],
      potencia: [produto?.potencia],
      cilindrada: [produto?.cilindrada],
      capacidadeMaximaTracao: [produto?.capacidadeMaximaTracao],
      distanciaEntreEixos: [produto?.distanciaEntreEixos],
      tipoVeiculo: [produto?.tipoVeiculo],
      especieVeiculo: [produto?.especieVeiculo],
      condicaoChassi: [produto?.condicaoChassi],
      condicao: [produto?.condicao],
      lotacao: [produto?.lotacao],
      bomba: [produto?.bomba],
      diluicao: [produto?.diluicao],
      indiceExpansao: [produto?.indiceExpansao],
      pphp: [produto?.pphp],

      cadastroParticipante: [produto?.cadastroParticipante],
      fatTabelaMedida: [produto?.fatTabelaMedida],
      fatGrupoprodutosUUID: [produto?.fatGrupoprodutosUUID],
      saldo: [produto?.saldo],
      prazoEntrega: [produto?.prazoEntrega],
      largura: [produto?.largura],
      altura: [produto?.altura],
      profundidade: [produto?.profundidade],
      tipoProdutoAutom: [produto?.tipoProdutoAutom],
      automBomba: [produto?.automBomba],
      searchUnidade1: '',
      searchUnidade2: '',
      searchUnidade3: '',
      searchUnidade4: '',
      searchUnidadePadrao: '',
      searchGrupo: [''],
      searchMarca: [''],
      searchAutomBomba: [''],
      searchClassificacaoGerencial: [''],
    });


    if (this.itemFormSub) {
      this.itemFormSub.unsubscribe();
    }

    this.setupFormListeners();
  }



  save(): BehaviorSubject<Produto | null> {
    if (this.itemForm.invalid) {
      this.validateAllFormFields(this.itemForm);
      this.snack.open('Por favor, preencha todos os campos obrigatórios!', 'OK', { duration: 5500 });
      return new BehaviorSubject<Produto | null>(null);
    }
    this.isSaving = true;
    const result = new BehaviorSubject<Produto | null>(null);
    this.produtoService.saveOrUpdate(this.itemForm.value).subscribe(
      val => {
        console.log(`salvou... ${JSON.stringify(val)}`);
        console.log(`classificacao... ${JSON.stringify(this.itemForm.value.classificacaoGerencial)}`);
        this.confirmService.confirm({
          title: 'S U C E S S O !',
          icon: 'check_circle',
          message: 'OK, PRODUTO SALVO COM SUCESSO !', error: false
        });
        result.next(val);
      },
      err => {
        this.confirmService.confirm({
          icon: 'error',
          title: 'A T E N Ç Ã O !',
          message: `A T E N Ç Ã O ! ERRO AO SALVAR PRODUTO: ${err.error.status}`,
          error: true
        });
      }
    ).add(() => this.isSaving = false);
    return result;
  }

  submit(): void {
    const result = this.save();
    // Modo seletor (aberto pelo LancamentoItens com selecionarAoSalvar): ao salvar com sucesso,
    // fecha o dialog devolvendo o produto salvo para o chamador selecioná-lo automaticamente.
    if (this.data?.selecionarAoSalvar) {
      result.subscribe((prod) => {
        if (prod) {
          this.dialogRefProdutoDetail.close(prod);
        }
      });
    }
  }

  fc(controlName: string): FormControl {
    return (this.itemForm?.get(controlName) as FormControl) || this.emptyControl;
  }

  // onFocusGrupo() {
  //   this.itemForm.get('fatGrupoprodutos').valueChanges
  //     .pipe(
  //       debounceTime(500),
  //       tap(() => this.isLoadingGrupo = true),
  //       switchMap(value => ((typeof (value) === 'string') ?
  //         (value !== undefined && value !== '' ? this.grupoService.getProdutoGrupoPageSearch(1, 10, value) :
  //           this.grupoService.getProdutoGrupoPage(1, 10)) : new Observable<PageResult<GrupoProdutos>>())
  //         .pipe(
  //           finalize(() => this.isLoadingGrupo = false),
  //         )
  //       )
  //     )
  //     .subscribe(grupos => this.grupos = grupos.content);
  // }

  // onSelectionChangeGrupo(event: any): void {
  //   if (event.option.value !== undefined) {
  //     this.grupo = event.option.value;
  //   }
  // }

  // displayFnGrupo(grupo: GrupoProdutos) {
  //   if (grupo) {
  //     return `${grupo.id} - ${grupo.descricao.trim()}`;
  //   }
  // }

  // onFocusFatMarca() {
  //   this.itemForm.get('fatMarca').valueChanges
  //     .pipe(
  //       debounceTime(500),
  //       tap(() => this.isLoadingFatMarca = true),
  //       switchMap(value => ((typeof (value) === 'string') ?
  //         (value !== undefined && value !== '' ? this.fatMarcaService.getMarcaPageSearch(1, 10, value) :
  //           this.fatMarcaService.getMarcaPage(1, 10)) : new Observable<PageResult<Marca>>())
  //         .pipe(
  //           finalize(() => this.isLoadingFatMarca = false),
  //         )
  //       )
  //     )
  //     .subscribe(fatMarcas => this.fatMarcas = fatMarcas.content);
  // }

  // onSelectionChangeFatMarca(event: any): void {
  //   if (event.option.value !== undefined) {
  //     this.fatMarca = event.option.value;
  //   }
  // }

  // displayFnFatMarca(fatMarca: Marca) {
  //   if (fatMarca) {
  //     return `${fatMarca.id} - ${fatMarca.descricao.trim()}`;
  //   }
  // }

  // addFatMarca() {
  //   console.log('Adiciona Marca');
  // }





  onSelectionChangeCadUnidade1(event: any): void {
    if (event.value !== undefined) {
      this.cadUnidade1 = event.value;
      this.clearSearchControl('searchUnidade1');
    }
  }




  onFocusCadUnidade2() {
    this.itemForm.get('cadUnidade2').valueChanges
      .pipe(
        debounceTime(500),
        tap(() => this.isLoadingCadUnidade2 = true),
        switchMap(value => ((typeof (value) === 'string') ?
          (value !== undefined && value !== '' ? this.unMedidaService.getUnMedidaPageSearch(1, 10, value) :
            this.unMedidaService.getUnMedidaPage(1, 10)) : new Observable<PageResult<UnMedida>>())
          .pipe(
            finalize(() => this.isLoadingCadUnidade2 = false),
          )
        )
      )
      .subscribe(unidades => this.unidades$.next(unidades.content));
  }

  onSelectionChangeCadUnidade2(event: any): void {
    if (event.value !== undefined) {
      this.cadUnidade2 = event.value;
      this.clearSearchControl('searchUnidade2');
    }
  }

  onFocusCadUnidade3() {
    this.itemForm.get('cadUnidade3').valueChanges
      .pipe(
        debounceTime(500),
        tap(() => this.isLoadingCadUnidade3 = true),
        switchMap(value => ((typeof (value) === 'string') ?
          (value !== undefined && value !== '' ? this.unMedidaService.getUnMedidaPageSearch(1, 10, value) :
            this.unMedidaService.getUnMedidaPage(1, 10)) : new Observable<PageResult<UnMedida>>())
          .pipe(
            finalize(() => this.isLoadingCadUnidade3 = false),
          )
        )
      )
      .subscribe(unidades => this.unidades$.next(unidades.content));
  }

  onSelectionChangeCadUnidade3(event: any): void {
    if (event.value !== undefined) {
      this.cadUnidade3 = event.value;
      this.clearSearchControl('searchUnidade3');
    }
  }

  onFocusCadUnidade4() {
    this.itemForm.get('cadUnidade4').valueChanges
      .pipe(
        debounceTime(500),
        tap(() => this.isLoadingCadUnidade4 = true),
        switchMap(value => ((typeof (value) === 'string') ?
          (value !== undefined && value !== '' ? this.unMedidaService.getUnMedidaPageSearch(1, 10, value) :
            this.unMedidaService.getUnMedidaPage(1, 10)) : new Observable<PageResult<UnMedida>>())
          .pipe(
            finalize(() => this.isLoadingCadUnidade4 = false),
          )
        )
      )
      .subscribe(unidades => this.unidades$.next(unidades.content));
  }

  onSelectionChangeCadUnidade4(event: any): void {
    if (event.value !== undefined) {
      this.cadUnidade4 = event.value;
      this.clearSearchControl('searchUnidade4');
    }
  }

  onFocusCadUnidadePadraoVenda() {
    this.itemForm.get('cadUnidadePadraoVenda').valueChanges
      .pipe(
        debounceTime(500),
        tap(() => this.isLoadingCadUnidadePadraoVenda = true),
        switchMap(value => ((typeof (value) === 'string') ?
          (value !== undefined && value !== '' ? this.unMedidaService.getUnMedidaPageSearch(1, 10, value) :
            this.unMedidaService.getUnMedidaPage(1, 10)) : new Observable<PageResult<UnMedida>>())
          .pipe(
            finalize(() => this.isLoadingCadUnidadePadraoVenda = false),
          )
        )
      )
      .subscribe(unidades => this.unidades$.next(unidades.content));
  }

  onSelectionChangeCadUnidadePadraoVenda(event: any): void {
    if (event.value !== undefined) {
      this.cadUnidadePadraoVenda = event.value;
      this.clearSearchControl('searchUnidadePadrao');
    }
  }




  addGrupo() {
  }



  openLcto(controle: number) {
    this.loader.open();
    this.fatDoctoCService.getFatDoctoC(controle).subscribe(val => {
      this.openPopUp(val);
      this.loader.close();
    }, ee => {
      this.loader.close();
      this.confirmService.confirm({ message: `ERRO AO CARREGAR LCTO: ${ee}`, error: true })
    }, () => {
      this.loader.close();
    });
  }

  openPopUp(data: any = {}) {

    this.dialogRef = this.dialog.open(LancamentoDetailsComponent, {
      width: this.layout.isMobile ? '100vw' : '98%',
      maxWidth: '100vw',
      height: this.layout.isMobile ? '100dvh' : '90vh',
      maxHeight: '100dvh',
      panelClass: this.layout.isMobile ? ['dialog-fullscreen'] : undefined,
      disableClose: false,
      data: { payload: data, openAsModal: true }
    });


    if (this.dialogRef) {
      this.dialogRef.disableClose = true;
      this.dialogRef.backdropClick().subscribe(_ => {
        if (this.dialog.openDialogs.length > 0) {
          const cn = confirm('Deseja realmente sair ?')
          if (cn) {
            this.dialogRef.close();
          }
        }
      })
    }

    this.dialogRef.afterClosed()
      .subscribe(res => {
        if (!res) {
          return;
        }
        this.loader.open();
        this.fatDoctoCService.saveOrUpdate(res)
          .subscribe(() => {
            this.loader.close();
            this.snack.open('Registro salvo com sucesso!', 'OK', { duration: 5500 })
          }, () => {
            this.loader.close();
            this.snack.open('Erro ao salvar o Registro!', 'ERRO', { duration: 5500 });
          })
      })
  }

  close() {
    // No modo seletor (novo produto sem id, aberto como dialog pelo LancamentoItens) fecha o
    // dialog em vez de navegar para a lista — senão sairia do contexto do lançamento.
    if (this.data?.produto?.id || this.data?.selecionarAoSalvar) {
      this.dialogRefProdutoDetail.close()
    } else {
      this.router.navigateByUrl('/produto_detail/list');
    }
  }

  print() {
    window.print();
  }


  /**
   * Abre Cadastro/configuracao Código de Barras
   * @param prod
   * @returns
   */
  openCodbarPopUp(prod: any = {}) {
    // if(this.verifyIsNotSaved(prod.value))return;
    const title = 'Código de Barras Produto: ';
    const safeProd = prod || {};
    const codigo = safeProd?.codigo ?? 'NOVO';
    const descricao = safeProd?.descricao ?? 'Produto';
    const dialogRef: MatDialogRef<any> = this.dialog.open(ProdutoCodbarPopupComponent, {
      width: this.layout.isMobile ? '100vw' : '40%',
      maxWidth: '100vw',
      height: this.layout.isMobile ? '100dvh' : undefined,
      maxHeight: '100dvh',
      disableClose: true,
      panelClass: this.layout.isMobile ? ['dialog-fullscreen'] : undefined,
      data: { title: `${title}[ ${codigo} - ${descricao} ]`, payload: safeProd }
    })
    dialogRef.afterClosed()
      .subscribe(res => {
        if (!res) {
          return;
        }
        this.getProduto();
      })
  }

  /**
   * Abre Movimentações
   * @param prod
   * @returns
   */
  openMovtoPopUp(prod: any = {}) {
    // if(this.verifyIsNotSaved(prod.value))return;
    const title = 'Movimentações Produto: ';
    const dialogRef: MatDialogRef<any> = this.dialog.open(ProdutoMovtoPopupComponent, {
      width: this.layout.isMobile ? '100vw' : '98%',
      maxWidth: '100vw',
      height: this.layout.isMobile ? '100dvh' : undefined,
      maxHeight: '100dvh',
      disableClose: true,
      panelClass: this.layout.isMobile ? ['dialog-fullscreen'] : undefined,
      data: { title: title + '[ ' + prod.codigo + ' - ' + prod.descricao + ' ]', payload: prod }
    })
    dialogRef.afterClosed()
      .subscribe(res => {
        if (!res) {
          return;
        }
        this.getProduto();
      })
  }

  /**
   * Abre Tributação
   * @param prod
   * @returns
   */
  openTribPopUp(prod: any = {}) {
    // if(this.verifyIsNotSaved(prod.value))return;
    const title = 'Tributação Produto: ';
    this.dialogRefTrib = this.dialog.open(ProdutoTribPopupComponent, {
      width: this.layout.isMobile ? '100vw' : '60%',
      maxWidth: '100vw',
      height: this.layout.isMobile ? '100dvh' : 'auto',
      maxHeight: '100dvh',
      disableClose: true,
      panelClass: this.layout.isMobile ? ['dialog-fullscreen'] : undefined,
      data: { title: `${title} [ ${prod.codigo} - ${prod.descricao} ]`, payload: prod }
    });
    this.dialogRefTrib.afterClosed().subscribe(res => {
      if (!res) {
        return;
      }
      this.getProduto();
    });
  }






  /**
   * Abre Preços
   * @param prod
   * @returns
   */
  openPrecoPopUp(prod: any = {}) {
    // if(this.verifyIsNotSaved(prod.value))return;
    const title = 'PREÇOS PRODUTO: ';
    const dialogRef: MatDialogRef<any> = this.dialog.open(ProdutoPrecoPopupComponent, {
      width: this.layout.isMobile ? '100vw' : '98%',
      maxWidth: '100vw',
      height: this.layout.isMobile ? '100dvh' : undefined,
      maxHeight: '100dvh',
      disableClose: true,
      panelClass: this.layout.isMobile ? ['dialog-fullscreen'] : undefined,
      data: { title: title + '[ ' + prod.codigo + ' - ' + prod.descricao + ' ]', payload: prod }
    })
    dialogRef.afterClosed()
      .subscribe(res => {
        if (!res) {
          return;
        }
        this.getProduto();
      })
  }

  /**
   * Abre Codigo/Foto
   * @param prod
   * @returns
   */
  openImagesPopUp(prod: any = {}) {

    // if(this.verifyIsNotSaved(prod.value))return;
    const title = 'Imagens/Foto Produto:';
    const dialogRef: MatDialogRef<any> = this.dialog.open(ProdutoImagesPopupComponent, {
      width: this.layout.isMobile ? '100vw' : '98%',
      maxWidth: '100vw',
      height: this.layout.isMobile ? '100dvh' : undefined,
      maxHeight: '100dvh',
      disableClose: true,
      panelClass: this.layout.isMobile ? ['dialog-fullscreen'] : undefined,
      data: { title: title + '[ ' + prod.codigo + ' - ' + prod.descricao + ' ]', payload: prod }
    })
    dialogRef.afterClosed()
      .subscribe(res => {
        if (!res) {
          return;
        }
        this.getProduto();
      })
  }


  /**
   * Verifica se o produto foi salvo
   * @param prod
   * @param showMessage
   * @returns
   */

  compareFn = (a: any, b: any): boolean => a && b && a.id === b.id;

  verifyIsNotSaved(prod: any, showMessage = true): boolean {
    console.log(`verifyIsNotSaved >>>>>> ${prod.id}`);
    const id = prod.id;
    if (id === undefined || id === null || id === 0) {
      if (showMessage) {
        this.confirmService.confirm(
          {
            message: 'Por favor, salve o Produto e tente novamente !!',
            error: true
          }
        );
      }
      return true;
    }
    return false;
  }

  openAnexoUploadListPopUp(prod: any = {}) {
    console.log(prod?.id ?? -1);

    if (this.verifyIsNotSaved(prod)) {
      return;
    }
    const title = 'Anexos: ';
    const dialogRef: MatDialogRef<any> = this.dialog.open(ProdutoAnexoUploadListComponent, {
      width: this.layout.isMobile ? '100vw' : '80%',
      maxWidth: '100vw',
      height: this.layout.isMobile ? '100dvh' : undefined,
      maxHeight: '100dvh',
      disableClose: true,
      panelClass: this.layout.isMobile ? ['dialog-fullscreen'] : undefined,
      data: { title: title + '[ ' + prod.codigo + ' - ' + prod.descricao + ' ]', payload: prod }
    })
    dialogRef.afterClosed()
      .subscribe(res => {
        if (!res) {
          return;
        }
        this.getProduto();
      })
  }

  validateAllFormFields(formGroup: FormGroup) {
    Object.keys(formGroup.controls).forEach(field => {
      const control = formGroup.get(field);
      if (control instanceof FormControl) {
        control.markAsTouched({ onlySelf: true });
      } else if (control instanceof FormGroup) {
        this.validateAllFormFields(control);
      }
    });
  }




}
